import { cva } from '@/styled-system/css';

export const menuItemLabelRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'label',
    textStyle: 'body',
  },
  variants: {
    anchor: {
      true: {
        color: { base: 'Menu.ItemLabel.text.anchor.label.default' },
      },
      false: {
        color: { base: 'Menu.ItemLabel.text.label.default' },
      },
    },
    disabled: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      anchor: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Menu.ItemLabel.text.anchor.label.hover',
          _groupActive: 'Menu.ItemLabel.text.anchor.label.pressed',
        },
      },
    },
    {
      anchor: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'Menu.ItemLabel.text.label.hover',
          _groupActive: 'Menu.ItemLabel.text.label.pressed',
        },
      },
    },
  ],
});
